export interface GameSettingsState {
    showStatsUI: string | null;
}

export const INIT_GAME_SETTINGS_STATE: GameSettingsState = {
    showStatsUI: null
};
